// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"3867bcd7","253":"3867bcd7","323":"3867bcd7","332":"3867bcd7","529":"3867bcd7","534":"3867bcd7","844":"3867bcd7","969":"3867bcd7"}[chunkId] + ".chunk.css";
};